import React, { useState } from 'react';
import NavigationBar from '../navbar/NavigationBar';
import Footer from '../navbar/Footer';
import {
  Box,
  Typography,
  Container,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Grid,
  Divider,
  IconButton,
  Tooltip,
  TextField,
  List, 
  ListItem, 
  ListItemIcon,
  ListItemText,
  CssBaseline,
  Drawer,
  InputAdornment,
  Button,
  useTheme,
  styled,
  useMediaQuery,
  Collapse,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  ListItemButton,
  Link,
  Menu,
  MenuItem,
  Card,
  CardContent,
  Stack
} from '@mui/material';
import {
  Layers,
  ExpandLess,
  InsertDriveFile,
  Description,
  MoreVert,
  Search,
  FileCopy,
  Download,
  Share,
  Home,
  Nature,
  Menu as MenuIcon,
  School,
  Close,
  FamilyRestroom,
  Man,
  TrendingUp,
  Public,
  ExpandMore,
  Email,
  WhatsApp,
  Bluetooth,
  Groups,
  LocalHospital,
  Person,
  Grass,
  Spa,
  BugReport,
  Hive,
  Water as WaterIcon,
  Groups3,
  Handshake,
  Diversity3,
  House,
  Roofing,
  Map,
  Pets as LivestockIcon,
  EggAlt as PoultryIcon,
  Cottage as EmergencyHomeIcon, 
  AccessibilityNew, 
  ChildCare, 
  Terrain, 
  PictureAsPdf,
  Engineering 
} from '@mui/icons-material';

// Constantes de style
const drawerWidth = 240;
const primaryColor = '#E30613';
const secondaryColor = '#008D36';
const backgroundColor = '#f5f5f5';

// Composants stylisés
const MainContainer = styled('div')({
  display: 'flex',
  backgroundColor: backgroundColor,
  minHeight: '100vh',
  flexDirection: 'column'
});

const MainContentWithDrawer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexGrow: 1,
  marginTop: '64px',
  overflow: 'hidden',
  [theme.breakpoints.down('sm')]: {
    marginTop: '56px'
  }
}));

const ContentWrapper = styled('main')(({ theme }) => ({
  flexGrow: 1,
  overflow: 'auto',
  padding: theme.spacing(2),
  backgroundColor: backgroundColor,
  height: 'calc(100vh - 64px)',
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(1),
    height: 'calc(100vh - 56px)'
  }
}));

const DrawerWrapper = styled('div')(({ theme }) => ({
  width: drawerWidth,
  flexShrink: 0,
  overflow: 'auto',
  height: 'calc(100vh - 64px)',
  borderRight: '1px solid rgba(0, 0, 0, 0.12)',
  backgroundColor: '#fff',
  [theme.breakpoints.down('md')]: {
    position: 'fixed',
    zIndex: 1300,
    transition: theme.transitions.create('transform', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    '&.drawerOpen': {
      transform: 'translateX(0)',
    },
    '&.drawerClose': {
      transform: 'translateX(-100%)',
    },
  }
}));

const MobileDrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
}));

const StyledTableHead = styled(TableHead)({
  backgroundColor: primaryColor,
  '& th': {
    color: 'white',
    fontWeight: 'bold'
  }
});

const ProvinceRow = styled(TableRow)({
  backgroundColor: '#e0e0e0',
  fontWeight: 'bold',
  '&:hover': {
    backgroundColor: '#d0d0d0 !important'
  }
});

const CommuneRow = styled(TableRow)({
  '&:hover': {
    backgroundColor: '#f5f5f5 !important'
  }
});

const menuItems = [
  { text: 'Ménages par type', icon: <FamilyRestroom color="primary" />, to: '/RGPHAEDataPage' },
  { text: 'Population par localisation', icon: <Public color="primary" />, to: '/PopulationDataPage' },
  { text: 'Ménages collectifs', icon: <Groups color="primary" />, to: '/PopulationCollectiveHouseholdsPage' },
  { text: 'Sans-abris', icon: <EmergencyHomeIcon color="primary" />, to: '/HomelessPopulationPage' },
  { text: 'Ménages ordinaires', icon: <Home color="primary" />, to: '/PopulationResidentPage' },
  { text: 'Sexe et masculinité', icon: <Man color="primary" />, to: '/PopulationDataPageM' },
  { text: 'Rapport de masculinité', icon: <TrendingUp color="primary" />, to: '/MasculinityRatioPage' },
  { text: 'Population par âge', icon: <ChildCare color="primary" />, to: '/PopulationDataPageAge' },
  { text: "Grands groupes d'âge", icon: <AccessibilityNew color="primary" />, to: '/PopulationAgeGroupPageGrand' },
  { text: "Groupes d'âge (éducation)", icon: <School color="primary" />, to: '/PopulationByAgeGroupPage' },
  { text: 'Groupes d\'âge (santé)', icon: <LocalHospital color="primary" />, to: '/AgeGroupPopulationPage' },
  { text: 'Adultes (18+)', icon: <Person color="primary" />, to: '/AdultPopulationPage' },
  
  // Agriculture
  { text: 'Ménages agricoles', icon: <Nature color="primary" />, to: '/AgriculturalHouseholdsPage' },
  { text: 'Pratiques agricoles', icon: <Grass color="primary" />, to: '/AgriculturalHouseholdsPages' },
  { text: 'Types de cultures', icon: <Spa color="primary" />, to: '/AgriculturalHouseholdsPage20' },
  
  // Élevage
  { text: 'Élevage par espèces', icon: <LivestockIcon color="primary" />, to: '/FarmingHouseholdsPage' },
  { text: 'Élevage de volailles', icon: <PoultryIcon color="primary" />, to: '/poultryFarmingPage' },
  { text: 'Élevage spécial', icon: <BugReport color="primary" />, to: '/insectFarmingHouseholdsPage' },
  { text: 'Répartition cheptel', icon: <LivestockIcon color="primary" />, to: '/livestockDistributionPage' },
  { text: 'Répartition volailles', icon: <PoultryIcon color="primary" />, to: '/poultryDistributionPage' },
  
  // Matériel agricole
  { text: 'Équipements agricoles', icon: <Engineering color="primary" />, to: '/agriculturalEquipmentPage' },
  { text: 'Apiculture', icon: <Hive color="primary" />, to: '/beekeepingHouseholdsPage' },
  { text: 'Pêche/aquaculture', icon: <WaterIcon color="primary" />, to: '/fishingHouseholdsPage' },
  
  // Associations
  { text: 'Interventions associations', icon: <Groups3 color="primary" />, to: '/associationInterventionPage' },
  { text: 'Interventions coopératives', icon: <Handshake color="primary" />, to: '/cooperativeInterventionPage' },
  { text: 'Interventions ONG', icon: <Diversity3 color="primary" />, to: '/interventionProjectsPage' },
  
  // Habitat
  { text: "Type d'habitat", icon: <House color="primary" />, to: '/housingDistributionPage' },
  { text: 'Matériau toit', icon: <Roofing color="primary" />, to: '/roofMaterialPage' },
  { text: 'Matériau sol', icon: <Layers color="primary" />, to: '/housingMaterialPage' },
  { text: 'Ménages agricoles', icon: <Terrain color="primary" />, to: '/agriculturalHouseholdsPageProvCom' },
  { text: 'Population par âge/résidence', icon: <Map color="primary" />, to: '/populationAgeResidencePage' },
];

// Structure des données
const associationData = {
  title: "Répartition des collines/quartiers par province/commune selon les domaines d'intervention des associations ou groupements",
  columns: [
    "Pas d'association ou groupement",
    "Agriculture",
    "Elevage",
    "Pêche",
    "Aquaculture",
    "Foresterie"
  ],
  provinces: [
    {
      name: "BUHUMUZA",
      communes: [
        { name: "BUTAGANZWA", values: ["13", "30", "27", "-", "1", "3"] },
        { name: "BUTIHINDA", values: ["23", "71", "56", "3", "-", "-"] },
        { name: "CANKUZO", values: ["3", "35", "29", "-", "-", "2"] },
        { name: "GISAGARA", values: ["4", "53", "51", "-", "2", "5"] },
        { name: "GISURU", values: ["23", "61", "52", "-", "2", "3"] },
        { name: "MUYINGA", values: ["23", "111", "90", "-", "2", "4"] },
        { name: "RUYIGI", values: ["12", "40", "28", "1", "4", "1"] }
      ],
      values: ["101", "401", "333", "4", "11", "18"]
    },
    {
      name: "BUJUMBURA",
      communes: [
        { name: "BUBANZA", values: ["8", "41", "31", "1", "2", "6"] },
        { name: "BUKINANYANA", values: ["11", "32", "36", "1", "-", "3"] },
        { name: "CIBITOKE", values: ["11", "24", "17", "1", "2", "3"] },
        { name: "ISARE", values: ["13", "24", "23", "-", "1", "1"] },
        { name: "MPANDA", values: ["4", "42", "35", "3", "2", "2"] },
        { name: "MUGERE", values: ["17", "38", "30", "3", "3", "10"] },
        { name: "MUGINA", values: ["11", "35", "27", "-", "-", "2"] },
        { name: "MUHUTA", values: ["9", "29", "23", "-", "-", "2"] },
        { name: "MUKAZA", values: ["9", "10", "11", "-", "-", "-"] },
        { name: "NTAHANGWA", values: ["38", "50", "36", "3", "3", "4"] },
        { name: "RWIBAGA", values: ["8", "33", "26", "-", "1", "1"] }
      ],
      values: ["139", "358", "295", "12", "14", "34"]
    },
    {
      name: "BURUNGA",
      communes: [
        { name: "BURURI", values: ["14", "54", "43", "-", "1", "4"] },
        { name: "MAKAMBA", values: ["28", "57", "53", "-", "-", "3"] },
        { name: "MATANA", values: ["12", "50", "41", "1", "-", "-"] },
        { name: "MUSONGATI", values: ["27", "58", "54", "-", "3", "5"] },
        { name: "NYANZA", values: ["23", "53", "49", "4", "2", "2"] },
        { name: "RUMONGE", values: ["14", "47", "40", "2", "3", "3"] },
        { name: "RUTANA", values: ["17", "61", "51", "2", "1", "6"] }
      ],
      values: ["135", "380", "331", "9", "10", "23"]
    },
    {
      name: "BUTANYERERA",
      communes: [
        { name: "BUSONI", values: ["9", "73", "62", "4", "4", "5"] },
        { name: "KAYANZA", values: ["57", "53", "34", "-", "1", "1"] },
        { name: "KIREMBA", values: ["23", "74", "68", "1", "1", "2"] },
        { name: "KIRUNDO", values: ["39", "94", "78", "7", "8", "6"] },
        { name: "MATONGO", values: ["17", "68", "59", "-", "3", "17"] },
        { name: "MUHANGA", values: ["9", "70", "59", "2", "1", "18"] },
        { name: "NGOZI", values: ["16", "72", "67", "3", "1", "9"] },
        { name: "TANGARA", values: ["14", "73", "66", "2", "1", "1"] }
      ],
      values: ["184", "577", "493", "19", "20", "59"]
    },
    {
      name: "GITEGA",
      communes: [
        { name: "BUGENDANA", values: ["6", "33", "31", "1", "1", "9"] },
        { name: "GISHUBI", values: ["38", "59", "49", "-", "1", "1"] },
        { name: "GITEGA", values: ["12", "109", "99", "1", "-", "1"] },
        { name: "KARUSI", values: ["28", "64", "48", "-", "4", "4"] },
        { name: "KIGANDA", values: ["8", "41", "35", "-", "-", "2"] },
        { name: "MURAMVYA", values: ["10", "33", "28", "-", "-", "3"] },
        { name: "MWARO", values: ["18", "48", "39", "-", "-", "1"] },
        { name: "NYABIHANGA", values: ["23", "46", "35", "-", "-", "2"] },
        { name: "SHOMBO", values: ["18", "40", "36", "-", "5", "-"] }
      ],
      values: ["161", "473", "400", "2", "11", "23"]
    }
  ],
  total: ["720", "2 189", "1 852", "46", "66", "157"]
};

const AssociationInterventionPage = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [searchTerm, setSearchTerm] = useState('');
  const [mobileOpen, setMobileOpen] = useState(false);
  const [expandedProvinces, setExpandedProvinces] = useState({});
  const [shareAnchorEl, setShareAnchorEl] = useState(null);
  const [downloadAnchorEl, setDownloadAnchorEl] = useState(null);
  const [openKeyStats, setOpenKeyStats] = useState(true);
  
  const handleCopyTable = () => {
    let tableContent = "Province/Commune\t" + associationData.columns.join("\t") + "\n";
    
    // Ajout des données totales
    tableContent += `BURUNDI\t${associationData.total.join("\t")}\n`;
    
    // Ajout des données par province et commune
    associationData.provinces.forEach(province => {
      tableContent += `${province.name}\t${province.values.join("\t")}\n`;
      
      province.communes.forEach(commune => {
        tableContent += `  ${commune.name}\t${commune.values.join("\t")}\n`;
      });
    });
    
    navigator.clipboard.writeText(`${associationData.title}\n\n${tableContent}`)
      .then(() => alert('Tableau copié dans le presse-papier'))
      .catch(err => console.error('Erreur lors de la copie:', err));
  };

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const toggleProvince = (provinceName) => {
    setExpandedProvinces(prev => ({
      ...prev,
      [provinceName]: !prev[provinceName]
    }));
  };

  const handleShareMenuOpen = (event) => {
    setShareAnchorEl(event.currentTarget);
  };

  const handleDownloadMenuOpen = (event) => {
    setDownloadAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setShareAnchorEl(null);
    setDownloadAnchorEl(null);
  };

  const shareVia = (method) => {
    handleMenuClose();
    const text = `Découvrez les données des associations/groupements du Burundi: ${associationData.title}`;
    const url = window.location.href;
    
    switch(method) {
      case 'whatsapp':
        window.open(`https://wa.me/?text=${encodeURIComponent(text + ' ' + url)}`, '_blank');
        break;
      case 'email':
        window.open(`mailto:?subject=${encodeURIComponent(text)}&body=${encodeURIComponent(url)}`, '_blank');
        break;
      case 'bluetooth':
        alert(`Partage via Bluetooth simulé: ${text}`);
        break;
      default:
        if (navigator.share) {
          navigator.share({
            title: text,
            url: url
          }).catch(err => console.log('Erreur de partage:', err));
        } else {
          navigator.clipboard.writeText(url);
          alert('Lien copié dans le presse-papier');
        }
    }
  };

  const downloadFile = (format) => {
    handleMenuClose();
    const blob = new Blob([JSON.stringify(associationData, null, 2)], { type: 'application/json' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `associations-groupements-burundi.${format}`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
    
    alert(`Téléchargement du fichier ${format} simulé`);
  };

  const filteredProvinces = associationData.provinces.map(province => {
    if (!searchTerm) return province;
    
    const filteredCommunes = province.communes.filter(commune =>
      commune.name.toLowerCase().includes(searchTerm.toLowerCase())
    );
    
    return {
      ...province,
      communes: filteredCommunes,
      show: filteredCommunes.length > 0 || 
            province.name.toLowerCase().includes(searchTerm.toLowerCase())
    };
  }).filter(province => province.show || !searchTerm);

  // Calcul des indicateurs clés
 const keyStats = {
  totalAssociations: associationData.total.reduce(
    (sum, val) => sum + parseInt(val.replace(/\s/g, '') || 0),
    0
  ),

  mostCommonDomain: associationData.columns[
    associationData.total.indexOf(
      Math.max(...associationData.total.map(val => parseInt(val.replace(/\s/g, '') || 0)))
    )
  ],

  provinceWithMostAssociations: associationData.provinces.reduce((max, province) => {
    const provinceTotal = province.values.reduce(
      (sum, val) => sum + parseInt(val.replace(/\s/g, '') || 0),
      0
    );
    const maxTotal = max.values.reduce(
      (sum, val) => sum + parseInt(val.replace(/\s/g, '') || 0),
      0
    );
    return provinceTotal > maxTotal ? province : max;
  }),

  provinceWithLeastAssociations: associationData.provinces.reduce((min, province) => {
    const provinceTotal = province.values.reduce(
      (sum, val) => sum + parseInt(val.replace(/\s/g, '') || 0),
      0
    );
    const minTotal = min.values.reduce(
      (sum, val) => sum + parseInt(val.replace(/\s/g, '') || 0),
      0
    );
    return provinceTotal < minTotal ? province : min;
  })
};
  // Composant du menu latéral
  const drawer = (
    <div>
      {isMobile && (
        <MobileDrawerHeader>
          <IconButton onClick={handleDrawerToggle}>
            <Close color="primary" />
          </IconButton>
        </MobileDrawerHeader>
      )}
      <Divider />
      <List>
        {menuItems.map((item) => (
          <ListItem key={item.text} disablePadding>
            <ListItemButton
              component={Link}
              to={item.to}
              onClick={isMobile ? handleDrawerToggle : undefined}
            >
              <ListItemIcon>{item.icon}</ListItemIcon>
              <ListItemText primary={item.text} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </div>
  );

  return (
    <MainContainer>
      <CssBaseline />
      <NavigationBar />
      <MainContentWithDrawer>
        {!isMobile ? (
          <DrawerWrapper>
            {drawer}
          </DrawerWrapper>
        ) : (
          <Drawer
            variant="temporary"
            open={mobileOpen}
            onClose={handleDrawerToggle}
            ModalProps={{
              keepMounted: true,
            }}
            sx={{
              '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
            }}
          >
            {drawer}
          </Drawer>
        )}

        <ContentWrapper>
          <Container maxWidth="lg">
            {isMobile && (
              <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2 }}>
                <Button 
                  variant="outlined" 
                  startIcon={<MenuIcon />} 
                  onClick={handleDrawerToggle}
                  sx={{ color: primaryColor, borderColor: primaryColor }}
                >
                  Menu
                </Button>
              </Box>
            )}
        
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <Paper sx={{ p: { xs: 1, sm: 3 }, mb: 3, borderLeft: `4px solid ${primaryColor}` }}>
                  <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, justifyContent: 'space-between', alignItems: { xs: 'flex-start', sm: 'center' }, mb: 2 }}>
                    <Typography variant="h6" component="h2" fontWeight="bold" color="primary" sx={{ mb: { xs: 1, sm: 0 } }}>
                      {associationData.title}
                    </Typography>
                  </Box>
                  <Grid container spacing={1} style={{ marginTop: '5px',marginBottom: '5px' }}>
                    <Grid item xs={12} sm={6} md={6} ></Grid>
                    <Grid item xs={12} sm={6} md={6}>
                      <TextField
                        size="small"
                        placeholder="Rechercher province/commune..."
                        variant="outlined"
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <Search />
                            </InputAdornment>
                          ),
                        }}
                        sx={{ width: { xs: '100%', sm: '480px' } }}
                      />
                    </Grid>
                  </Grid>
                  
                  {/* Section des indicateurs clés */}
                  <Accordion expanded={openKeyStats} onChange={() => setOpenKeyStats(!openKeyStats)} sx={{ mb: 3 }}>
                    <AccordionSummary expandIcon={<ExpandMore />}>
                      <Typography variant="subtitle1" fontWeight="bold">
                        Indicateurs Clés
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Grid container spacing={2}>
                        <Grid item xs={12} md={6} lg={4}>
                          <Card sx={{ height: '100%', borderLeft: `4px solid ${primaryColor}` }}>
                            <CardContent>
                              <Typography variant="subtitle2" color="text.secondary">
                                Total des associations
                              </Typography>
                              <Typography variant="h5" fontWeight="bold">
                                {keyStats.totalAssociations.toLocaleString()}
                              </Typography>
                              <Typography variant="caption">
                                Tous domaines confondus
                              </Typography>
                            </CardContent>
                          </Card>
                        </Grid>
                
                        
                        <Grid item xs={12} md={6} lg={4}>
                          <Card sx={{ height: '100%', borderLeft: `4px solid ${primaryColor}` }}>
                            <CardContent>
                              <Typography variant="subtitle2" color="text.secondary">
                                Province avec plus d'associations
                              </Typography>
                              <Typography variant="h6" fontWeight="bold">
                                {keyStats.provinceWithMostAssociations.name}
                              </Typography>
                              <Typography variant="body1">
                                {keyStats.provinceWithMostAssociations.values.reduce((sum, val) => sum + parseInt(val.replace(/\s/g, '') || 0), 0).toLocaleString()}
                              </Typography>
                            </CardContent>
                          </Card>
                        </Grid>
                        
                        <Grid item xs={12} md={6} lg={4}>
                          <Card sx={{ height: '100%', borderLeft: `4px solid ${secondaryColor}` }}>
                            <CardContent>
                              <Typography variant="subtitle2" color="text.secondary">
                                Province avec moins d'associations
                              </Typography>
                              <Typography variant="h6" fontWeight="bold">
                                {keyStats.provinceWithLeastAssociations.name}
                              </Typography>
                              <Typography variant="body1">
                                {keyStats.provinceWithLeastAssociations.values.reduce((sum, val) => sum + parseInt(val.replace(/\s/g, '') || 0), 0).toLocaleString()}
                              </Typography>
                            </CardContent>
                          </Card>
                        </Grid>
                      </Grid>
                    </AccordionDetails>
                  </Accordion>
                  
                  <TableContainer component={Paper} sx={{ mb: 2, overflowX: 'auto' }}>
                    <Table size="small" aria-label="Tableau des associations par domaine">
                      <StyledTableHead>
                        <TableRow>
                          <TableCell>Province/Commune</TableCell>
                          {associationData.columns.map((column, index) => (
                            <TableCell key={index} align="right">{column}</TableCell>
                          ))}
                        </TableRow>
                      </StyledTableHead>
                      <TableBody>
                        {/* Ligne pour le total Burundi */}
                        <ProvinceRow hover>
                          <TableCell component="th" scope="row" sx={{ fontWeight: 'bold' }}>
                            BURUNDI
                          </TableCell>
                          {associationData.total.map((value, index) => (
                            <TableCell key={index} align="right" sx={{ fontWeight: 'bold' }}>{value}</TableCell>
                          ))}
                        </ProvinceRow>

                        {/* Données par province et commune */}
                        {filteredProvinces.map((province, index) => (
                          <React.Fragment key={index}>
                            <ProvinceRow 
                              hover 
                              onClick={() => toggleProvince(province.name)}
                              sx={{ cursor: 'pointer' }}
                            >
                              <TableCell component="th" scope="row">
                                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                  {expandedProvinces[province.name] ? <ExpandLess /> : <ExpandMore />}
                                  {province.name}
                                </Box>
                              </TableCell>
                              {province.values.map((value, idx) => (
                                <TableCell key={idx} align="right">{value}</TableCell>
                              ))}
                            </ProvinceRow>
                            
                            <TableRow>
                              <TableCell style={{ padding: 0 }} colSpan={associationData.columns.length + 1}>
                                <Collapse in={expandedProvinces[province.name] || !!searchTerm} timeout="auto" unmountOnExit>
                                  <Table size="small" sx={{ backgroundColor: '#fafafa' }}>
                                    <TableBody>
                                      {province.communes.map((commune, idx) => (
                                        <CommuneRow key={idx} hover>
                                          <TableCell sx={{ pl: 6 }}>{commune.name}</TableCell>
                                          {commune.values.map((value, valIdx) => (
                                            <TableCell key={valIdx} align="right">{value}</TableCell>
                                          ))}
                                        </CommuneRow>
                                      ))}
                                    </TableBody>
                                  </Table>
                                </Collapse>
                              </TableCell>
                            </TableRow>
                          </React.Fragment>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                     {/*
                  <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
                    <Tooltip title="Copier le tableau">
                      <IconButton onClick={handleCopyTable} sx={{ color: primaryColor }}>
                        <FileCopy />
                      </IconButton>
                    </Tooltip>
                    
                    <Tooltip title="Télécharger les données">
                      <IconButton 
                        onClick={handleDownloadMenuOpen}
                        sx={{ color: secondaryColor }}
                      >
                        <Download />
                      </IconButton>
                    </Tooltip>
                    <Menu
                      anchorEl={downloadAnchorEl}
                      open={Boolean(downloadAnchorEl)}
                      onClose={handleMenuClose}
                    >
                      <MenuItem onClick={() => downloadFile('xlsx')}>
                        <ListItemIcon>
                          <InsertDriveFile fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>Excel (.xlsx)</ListItemText>
                      </MenuItem>
                      <MenuItem onClick={() => downloadFile('csv')}>
                        <ListItemIcon>
                          <Description fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>CSV (.csv)</ListItemText>
                      </MenuItem>
                      <MenuItem onClick={() => downloadFile('pdf')}>
                        <ListItemIcon>
                          <PictureAsPdf fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>PDF (.pdf)</ListItemText>
                      </MenuItem>
                    </Menu>
                    
                    <Tooltip title="Partager">
                      <IconButton 
                        onClick={handleShareMenuOpen}
                        sx={{ color: primaryColor }}
                      >
                        <Share />
                      </IconButton>
                    </Tooltip>
                    <Menu
                      anchorEl={shareAnchorEl}
                      open={Boolean(shareAnchorEl)}
                      onClose={handleMenuClose}
                    >
                      <MenuItem onClick={() => shareVia('whatsapp')}>
                        <ListItemIcon>
                          <WhatsApp fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>WhatsApp</ListItemText>
                      </MenuItem>
                      <MenuItem onClick={() => shareVia('email')}>
                        <ListItemIcon>
                          <Email fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>Email</ListItemText>
                      </MenuItem>
                      <MenuItem onClick={() => shareVia('bluetooth')}>
                        <ListItemIcon>
                          <Bluetooth fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>Bluetooth</ListItemText>
                      </MenuItem>
                      <MenuItem onClick={() => shareVia('other')}>
                        <ListItemIcon>
                          <MoreVert fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>Autre méthode</ListItemText>
                      </MenuItem>
                    </Menu>
                  </Box>
                  */}
                </Paper>
                
                {/* Section d'information */}
                <Accordion sx={{ mb: 2 }}>
                  <AccordionSummary expandIcon={<ExpandMore />}>
                    <Typography variant="subtitle2" color="primary">
                      À propos des associations et groupements
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Typography variant="body2" paragraph>
                      Cette section présente la répartition des associations et groupements par domaine d'intervention:
                    </Typography>
                    <List dense sx={{ py: 0 }}>
                      {associationData.columns.map((column, index) => (
                        <ListItem key={index}>
                          <ListItemText primary={`• ${column}`} />
                        </ListItem>
                      ))}
                    </List>
                    <Typography variant="body2" mt={2}>
                      Les données montrent que l'agriculture est le domaine le plus répandu avec {associationData.total[1]} associations, 
                      suivi de l'élevage avec {associationData.total[2]} groupements.
                    </Typography>
                  </AccordionDetails>
                </Accordion>
                
                {/* Notes méthodologiques */}
                <Paper sx={{ p: 2, backgroundColor: '#f0f0f0', borderLeft: `4px solid ${secondaryColor}` }}>
                  <Typography variant="subtitle2" gutterBottom color="primary">
                    Notes méthodologiques
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Les données présentées sont issues du Recensement Général de la Population, de l'Habitat, de l'Agriculture et Elevage (RGPHAE) 
                    réalisé en 2024. Les chiffres représentent le nombre de collines/quartiers où des associations ou groupements sont actifs 
                    dans chaque domaine d'intervention. Un tiret (-) indique qu'aucune association n'a été recensée dans ce domaine.
                  </Typography>
                </Paper>
              </Grid>
            </Grid>
          </Container>
        </ContentWrapper>
      </MainContentWithDrawer>
      <Footer />
    </MainContainer>
  );
};

export default AssociationInterventionPage;